import { render } from "./Open_Date_Message.vue?vue&type=template&id=028e1c77"
import script from "./Open_Date_Message.vue?vue&type=script&lang=js"
export * from "./Open_Date_Message.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__